import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export const generateQuotationPDF = (quotation) => {
  const isFrench = quotation.language === 'fr';
  const doc = new jsPDF('landscape');

  // Title
  doc.setFontSize(22);
  const titleText = isFrench ? 'Devis de Marque Privée' : 'Private Label Quotation';
  doc.text(titleText, 14, 20);

  // Customer Info
  doc.setFontSize(12);
  doc.text(`${isFrench ? 'Client' : 'Customer'}: ${quotation.customerName}`, 14, 30);
  doc.text(`Date: ${new Date(quotation.createdAt).toLocaleDateString()}`, 14, 37);
  doc.text(`${isFrench ? 'Statut' : 'Status'}: ${quotation.status}`, 14, 44);

  // Table Data
  const headers = isFrench
    ? [['SKU', 'Produit', 'Poids Net', 'Emballage', 'Unités/Caisse', 'Prix par Unité', 'Prix Total']]
    : [['SKU', 'Product', 'Net Weight', 'Packaging', 'Units/Case', 'Price per Unit', 'Total Price']];

  const body = quotation.items.map(item => [
    item.sku || 'N/A',
    item.productName || 'N/A',
    item.netWeight || 'N/A',
    item.packaging || 'N/A',
    item.unitsPerCase || 0,
    `$${(item.pricePerUnit || 0).toFixed(2)}`,
    `$${(item.calculatedPrice || 0).toFixed(2)}`
  ]);

  autoTable(doc, {
    startY: 55,
    head: headers,
    body: body,
    theme: 'striped',
    headStyles: { fillColor: [0, 0, 0] },
    margin: { top: 10 }
  });

  const finalY = doc.lastAutoTable.finalY || 55;
  doc.setFontSize(14);
  doc.text(`${isFrench ? 'Montant Total' : 'Total Amount'}: $${(quotation.totalAmount || 0).toFixed(2)}`, 14, finalY + 10);

  // Save the PDF
  const filename = `Quotation_${quotation.customerName.replace(/\s+/g, '_')}_${new Date(quotation.createdAt).getTime()}.pdf`;
  doc.save(filename);
};
